import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.666 8.167v11.666c0 2.578 4.179 4.667 9.333 4.667 5.155 0 9.334-2.09 9.334-4.667V8.167m-18.667 0c0 2.577 4.179 4.666 9.333 4.666 5.155 0 9.334-2.089 9.334-4.666m-18.667 0c0-2.578 4.179-4.667 9.333-4.667 5.155 0 9.334 2.09 9.334 4.667m0 5.833c0 2.577-4.179 4.667-9.334 4.667-5.154 0-9.333-2.09-9.333-4.667",
      stroke: "currentColor",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }